<div class="remote-control-error" *ngIf="deviceState.hasError">
  <div class="remote-control-error-caption">
    {{ 'remoteControlController_Error_Caption' | xsI18n }}
  </div>
  <div class="remote-control-error-message">{{ deviceState.errorMessage }}</div>
  <div
    class="btn btn-default btn-sm remote-control-force_override"
    type="button"
    *ngIf="allowOverride()"
    (click)="forceRemoteControlDevice()"
    uib-tooltip="{{ 'remoteControlController_Override_RC' | xsI18n }}"
    tooltip-placement="auto top"
  >
    <span>{{ 'remoteControlController_Override_btn' | xsI18n }}</span>
  </div>
</div>

<div class="remote-control-old-session" *ngIf="!isOpenSession() && !deviceState.hasError">
  <div class="remote-control-header-caption">{{ 'remoteControlActivity_Caption' | xsI18n }}</div>
  <div class="remote-control-header">
    <div class="remote-control-caption">{{ activity.createdBy | xsI18n }}</div>
    <div class="remote-control-date">
      <span class="activity-updating-time-short">{{ activity.creationDate | date: 'short' }}</span>
      <span class="activity-updating-time-regular">
        <xs-updating-time [hidespan]="true" [time]="activity.creationDate"></xs-updating-time>
      </span>
    </div>
  </div>
  <div class="fixed no-padding h5 subtext" *ngIf="isLoadingMessageVisible()">
    <div class="fa fa-circle-o-notch fa-spin remote-control-waiting"></div>
    <div class="remote-control-waiting">{{ message }}</div>
  </div>
  <div class="remote-control-body">
    <div class="remote-control-device-name">{{ getDeviceName() }}</div>
    <div class="remote-control-duration-value" *ngIf="!activity?.details?.terminationDate">
      {{ getDuration() }}
    </div>
  </div>
  <!--  <sa-email-attachment attachments="remoteControl.getVideoAttachments()" show-close="true" on-delete="remoteControl.removeVideoAttachment(attachment)"></sa-email-attachment>-->
</div>

<div
  class="remote-control-session-in-progress"
  *ngIf="isOpenSession() && !activity.details.terminationDate && !deviceState.hasError"
>
  <div class="remote-control-top-section">
    <div class="remote-control-header-caption">{{ 'remoteControlActivity_Caption' | xsI18n }}</div>
    <div class="spacer"></div>
    <div
      class="remote-control-button"
      *ngIf="!deviceState.poppedOut && deviceState.connected && !deviceStateRegistry.isLoading(deviceState.device)"
    >
      <button type="button" (click)="minimizeToggle()">
        <span [hidden]="deviceState.minimized" class="hd-icon hd-icon-minimize"></span>
        <span [hidden]="!deviceState.minimized" class="hd-icon hd-icon-maximize"></span>
      </button>
    </div>
    <div
      class="remote-control-button"
      *ngIf="
        showPopout &&
        !deviceState.poppedOut &&
        deviceState.connected &&
        !deviceStateRegistry.isLoading(deviceState.device)
      "
      [soti-tooltip]="getPopoutToolTip()"
      placement="left"
    >
      <button [disabled]="getPopoutIsDisabled()" (click)="popout()">
        <span class="hd-icon hd-icon-popout"></span>
      </button>
      <!-- Use uib (instead of both bootstrap syntaxes) since RC buttons aren't visible in SSP -->
    </div>
    <div class="remote-control-button" *ngIf="deviceState.connected">
      <button type="button" (click)="onClosingRC(deviceState.device)">
        <span class="hd-icon hd-icon-close"></span>
      </button>
    </div>
  </div>

  <div
    class="remote-control-header top-section"
    *ngIf="deviceStateRegistry.isLoading(deviceState.device) && !duration"
  >
    <div class="remote-control-caption">
      {{ 'remoteControlController_InitiatedBy_Caption' | xsI18n: getDeviceName() }}
    </div>
    <div class="remote-control-date">
      <span class="activity-updating-time-short">{{ activity.creationDate | date: 'short' }}</span>
      <span class="activity-updating-time-regular">
        <xs-updating-time [hidespan]="true" [time]="activity.creationDate"></xs-updating-time>
      </span>
    </div>
  </div>

  <div class="remote-control-header">
    <div class="remote-control-device-name" [hidden]="deviceStateRegistry.isLoading(deviceState.device)">
      {{ getDeviceName() }}
    </div>
  </div>

  <div class="remote-control-body" [hidden]="!deviceStateRegistry.isCurrentRemoteControlRunning()">
    <div class="remote-control-active-duration-caption">
      {{ 'remoteControlController_Duration_Caption' | xsI18n }}
    </div>
    <div class="remote-control-active-duration-value" id="activeDuration">{{ getDuration() }}</div>
  </div>
</div>
